module.exports = __webpack_public_path__ + "static/FreeScanTrak-2feaf0fc0b3a715df228399c9d9da2db.png";